module.exports = __webpack_public_path__ + "img/onboard.be50037c.webp";